module.exports = __webpack_public_path__ + "static/media/pexels-gdtography-950241.1281eaa5.jpeg";